<template>
    <b-modal id="prePrescribeDetailModal" :title="title" size="md">
        <div class="search user_modal">
            <div class="table_list">
                <div class="detail">
                    <div class="title_sm pt0">
                        <h3 class="tb_title">이전처방 상세</h3>
                    </div>
                    <table class="write">
                        <colgroup>
                            <col width="100">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>처방명</th>
                                <td><span>{{prePrescribeData.prescribe_nm}}</span></td>
                            </tr>
                            <tr>
                                <th>출전</th>
                                <td><span>{{prePrescribeData.prescribe_source}}</span></td>
                            </tr>
                            <tr>
                                <th>처방구성</th>
                                <td><span>{{prePrescribeData.prescribe_medicine}}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <template #modal-footer="{ ok }">
            <b-button @click="fn_click_apply()" class="btn btn_md btn_brown">반영</b-button>
            <b-button @click="ok" class="btn btn_md btn_brown">닫기</b-button>
        </template>
    </b-modal>

</template>

<script>
    export default {
        name: 'prePrescribeDetailModal',
        props: {
            title: String,
            prePrescribeData : {
                dictionary_nm : '',
                dictionary_source : '',
                prescribe_medicine : '',
                item : {}
            }
        },
        methods: {
            fn_click_apply(){
                this.$emit('callback', this.prePrescribeData.item);
            }          
        },
        data () {
            return {
            }
        }
    }
</script>

<style>

</style>